<template>
  <div class="popup_content">
    <v-popuptitle message="울산광역시교육청 검진비용 정산 안내" imgsrc="sub/ic_popup.png"></v-popuptitle>
    <div class="popup__con_inner tac">
      <div class="popup__item">
        <div class="popup__box">
          <p class="popup__text">
            2024. 9. 1. ~ 12. 4.까지의 비용 청구건에 대해서 마지막 3차 정산을 실시하여
            <br />
            2024. 12. 16.(월) 병원별 등록 계좌로 지급 완료되었음을 알려드립니다.
          </p>
          <p class="popup__sub mt20">
            각 병원에서는 덴티아이 &gt; 비용청구서 &gt; 청구금액에서 "처리완료" 금액과 실제 입금 금액을 확인하시고
            <br />
            이상이 있는 경우 052-210-5583으로 연락주시기 바랍니다.
          </p>
          <p class="popup__sub mt20">
            2024년 사업 종료에 따라 <strong>병원 행정처리 업무 관련 자료 다운로드는 12월 23일부터 12월 31일까지</strong>이오니
            <br />
            차질없이 다운받아 관련 업무 처리에 활용하시길 바랍니다.
          </p>
          <div class="popup__info mt15">
            <table>
              <colgroup>
                <col span="3" />
                <col width="195" />
              </colgroup>
              <thead>
                <tr>
                  <th>구분</th>
                  <th>일정</th>
                  <th>자료 목록</th>
                  <th>덴티아이 경로</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>
                    비용 청구ㆍ정산 내역<br />
                    다운로드
                  </th>
                  <td>12.23(월) ~ 12.31(화)</td>
                  <td>검진비 지급내역(엑셀)</td>
                  <td>
                    비용 청구서<br />
                    → [엑셀 다운로드] 버튼
                  </td>
                </tr>
                <tr>
                  <th>
                    검진 자료<br />
                    일괄 다운로드
                  </th>
                  <td>12.23(월) ~ 12.31(화)</td>
                  <td>
                    구강검진 문진표 및<br />
                    통보서(pdf)
                  </td>
                  <td>
                    학생 검진 메뉴<br />
                    → [일괄(PDF) 다운로드] 버튼
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="popup__sub mt20">※ 덴티아이 접속은 <strong>2024년 12월 31일까지만</strong> 가능합니다.</p>
        </div>
      </div>
      <div class="popup__close">
        <a href="javascript:;" @click="customClose('2024-07-31')">다시 보지 않기</a>
      </div>
    </div>
  </div>
</template>

<script>
import popupTitle from '@/components/popup/PopupTitle.vue';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    'v-popuptitle': popupTitle,
  },
  computed: {
    ...mapState('user', ['userOrganTargetType']),
    ...mapState('status', ['userOrganTargetTypeToPath']),
  },
  methods: {
    ...mapActions('popup', ['customClose']),
  },
};
</script>

<style scoped>
.popup__item {
  padding: 7px 80px 30px 80px;
}
.popup__box {
  padding: 30px 0;
  background: #fff;
  border: 1px solid #d1d1d1;
  border-radius: 5px;
  text-align: center;
}
.popup__text {
  line-height: 30px;
  font-size: 21px;
  font-weight: 700;
  color: #1c1c1c;
}
.popup__sub {
  line-height: 23px;
  font-size: 16px;
  color: #191919;
}
.popup__info {
  padding: 0 50px;
}
.popup__info table {
  border: 1px solid #cacaca;
}
.popup__info th,
.popup__info td {
  padding: 4px 13px;
  border-left: 1px solid #cacaca;
  line-height: 20px;
  font-size: 14px;
  color: #191919;
}
.popup__info th {
  font-weight: 700;
}
.popup__info td {
  text-align: left;
  font-weight: 400;
  letter-spacing: -0.5px;
}
.popup__info thead th {
  background-color: #f0f0f0;
}
.popup__info tbody th,
.popup__info tbody td {
  border-top: 1px solid #cacaca;
}
.popup__sm__text {
  font-size: 14px;
}
.popup__close {
  float: right;
  margin-right: 10px;
}
.popup__close a {
  padding: 10px 25px;
  margin-right: 10px;
  background-color: #f0f0f0;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #737373;
  vertical-align: middle;
}
</style>
